<template>
  <div class="oheight">
    <c-header></c-header>
    <div class="wrap">
      <c-menu></c-menu>
        <div class="content">
          <router-view></router-view>
        </div>
    </div>
  </div>
</template>

<script>
import cHeader from '../../../components/header.vue'
import cMenu from '../../../components/menu.vue'
import cFooter from '../components/footer.vue'
  import { getContentUserManInfo, queryContentUserManInfo } from '../../../api/man'
  import {mapState,mapMutations} from 'vuex'

export default {
  name: 'man',
  components: {
    cHeader,
    cMenu,
    cFooter
  },
  computed:{
    ...mapState([
      'imgHost',
      'userInfo'
    ])
  },
  mounted() {
      this._getContentUserManInfo();
      $('#account_type_error_123').remove();
  },
  methods:{
    ...mapMutations([
      'setUserInfo'
    ]),
    // 获取用户信息
    _getContentUserManInfo(){
      if(this.$commonJs.getTenantId())
      queryContentUserManInfo({
        tenantId: String(this.$commonJs.getTenantId()),
      }).then(res=>{
        console.log('queryContentUserManInfo -- man.vue  -- 47', res);
        if(res && res.pin){
          sessionStorage.setItem('user_identity',res.identity);
          sessionStorage.setItem('user_pin',res.pin);
          this.setUserInfo(res || {});
        }else{
          this.$router.push({
            path: "/logo",
            query: {
              returnUrl: window.location.href,
            },
          });
        }
      }).catch(error=>{
        
        this.$router.push({
            path: "/logo",
            query: {
              returnUrl: window.location.href,
            },
        });
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  .oheight {
    /*height: 100%;*/
  }
  .wrap{
    position: relative;
    margin-top: 1px;
    /*overflow: hidden;*/

    .cMenu{
      position: absolute;
      top: 0;
      left: 0;
      width: 180px;
      height: 100%;
      z-index: 1;
    }
    .content{
      position: relative;
      padding: 26px 25px 18px 26px;
      margin-left: 180px;
    }
  }
</style>
